export class MavlinkCRC {
    private static readonly X25_INIT_CRC = 0xffff;
    private static readonly X25_VALIDATE_CRC = 0xf0b8; // 61624

    /** Аналог crc_accumulate(byte b, ushort crc) */
    public static crcAccumulate(b: number, crc: number): number {
        let b2 = (b ^ (crc & 0xff)) & 0xff;
        b2 = (b2 ^ (b2 << 4)) & 0xff;
        return (
            ((crc >> 8) ^ (b2 << 8) ^ (b2 << 3) ^ (b2 >> 4)) & 0xffff
        );
    }

    /** Аналог crc_calculate(byte[] buffer, int length) */
    public static crcCalculate(buffer: Uint8Array, length: number): number {
        if (length < 1) return 0xffff;

        let crc = MavlinkCRC.X25_INIT_CRC;
        // ⚠️ В твоём C# коде цикл начинается с i = 1, не с 0!
        for (let i = 1; i < length; i++) {
            crc = MavlinkCRC.crcAccumulate(buffer[i] as number, crc);
        }
        return crc & 0xffff;
    }
}
